import React, {useEffect, useState} from "react";
import inquiryProcess from "../../tools/api/finCheck/inquiryProcess";
import createProcess from "../../tools/api/finCheck/createProcess";
import fetchProcess from "../../tools/api/finCheck/fetchProcess";
import bankingOTPSend from "../../tools/api/finCheck/bankingOTPSend";
import bankingOTPVerify from "../../tools/api/finCheck/bankingOTPVerify";

import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import initConfirm from "../../tools/api/finCheck/initConfirm";
import {calculateOtpTimer, divarLinkGenerator, persianToEnglish, safeRedirect} from "../../tools/helpers";
import createPayment from "../../tools/api/finCheck/createPayment";
import handleGenerateUuid from "../../tools/api/global/generateUuid";
import shahkar from "../../tools/api/finCheck/shahkar";
import FinCheckContext from "../../tools/contexts/finCheck/FincheckContext";
import PLATFORMS from "../../tools/defaults/Platforms";
import backChequesInquiry from "../../tools/api/finCheck/backChequesInquiry";
import facilityInquiry from "../../tools/api/finCheck/facilityInquiry";
import resetProcess from "../../tools/api/finCheck/resetProcess";
import DeleteWidgetModal from "./DeleteWidgetModal";
import deleteWidget from "../../tools/api/finCheck/deleteWidget";
import SuccessModal from "../modals/SuccessModal";
import {useNavigate} from "react-router-dom";
import useDivarAuth from "../../hooks/useDivarAuth";

const FinCheckProvider = ({children}) => {
    const navigate=useNavigate();
    const {token,postToken,returnUrl,serviceType}=useDivarAuth();
    const [pid, setPid] = useState(null);
    const [process, setProcess] = useState(null);
    const [components, setComponents] = useState(null);
    const [loading, setLoading] = useState({
        isLoading: false,
        message: 'لطفا منتظر بمانید.'
    });
    const [showOTP, setShowOTP] = useState(false);
    const [isReported, setIsReported] = useState(false);
    const [message, setMessage] = useState('');
    const [otpError, setOtpError] = useState(null);
    const [widget, setWidget] = useState(null)
    const updateOtpError = (newMessage) => {
        setOtpError(newMessage);
    }
    const updateLoadingState = (isLoading, message = 'لطفا منتظر بمانید.') => {
        setLoading({isLoading, message});
    };
    const handleRedirect = (status, price) => {
        const link= divarLinkGenerator({
            returnUrl,
            price,
            status,
        });
        safeRedirect(link,()=>{
            Reoverlay.showModal(ErrorModal,{
                title:'خطا',
                message:'لینک معتبر نمی باشد.',
                showCancelButton: true,
                cancelButtonText:'بستن',
                onCancel:()=>{
                    Reoverlay.hideModal();
                    navigate('/404')
                }
            })
        })
    }
    const handleError = (data, message, status, callback = () => {
    }, pid) => {
        if (status === -100) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                showCancelButton: true,
                cancelButtonText: 'ساخت فرایند جدید',
                onCancel: async () => {
                    await handleCreateProcess();
                }
            })
        } else if (status === -9) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                showCancelButton: true,
                cancelButtonText: 'بازگشت به دیوار',
                onCancel: () => {
                    handleRedirect("fail");
                }
            })
        } else if (status === -10) {
            setIsReported(true);
            setMessage(message);
        } else if (data.can_reset) {
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                showCancelButton: true,
                cancelButtonText: 'ویرایش اطلاعات',
                onCancel: async () => {
                    await handleResetProcess(pid)
                }
            })
        } else {
            callback();
        }
    };
    const handleInquiryProcess = async () => {
        updateLoadingState(true, 'لطفا منتظر بمانید');
        try {
            const params = {
                "service_type": serviceType,
                "post_token": postToken
            }
            const response = await inquiryProcess(token, params);
            const {data, message, status, hasError} = response;
            if (hasError) {
                handleError(data, message, status, () => {
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: message,
                        showCancelButton: true,
                        cancelButtonText: 'تلاش مجدد',
                        onCancel: async () => {
                            await handleInquiryProcess()
                        }
                    })
                })
            } else {
                if (data.widget && data.widget.has_widget) {
                    updateLoadingState(false)
                    setWidget(data.widget);

                } else {
                    if (data.process && data.process.pid && data.components.current_component.name !== PLATFORMS.DIVAR.APPS.FIN_CHECK.STEPS.FINAL) {
                        //have a process
                        await handleFetchProcess(data.process.pid);
                    } else {

                        await handleCreateProcess();
                    }
                }

            }
        } catch (error) {
            console.error("Inquiry Process Error:", error);
            updateLoadingState(false);
        }
    };
    const handleCreateProcess = async () => {
        const params = {
            "post_token": postToken,
        }
        updateLoadingState(true, 'در حال ساخت فرایند');
        try {
            const response = await createProcess(token, params);
            const {data, status, hasError, message} = response;
            if (hasError) {
                handleError(data, message, status, () => {
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: message,
                        showCancelButton: true,
                        cancelButtonText: 'تلاش مجدد',
                        onCancel: async () => {
                            await handleCreateProcess()
                        }
                    })
                })
            } else {
                await handleFetchProcess(data.pid)
            }
        } catch (error) {
            console.error("Create Process Error:", error);
            updateLoadingState(false);
        }
    };
    const handleFetchProcess = async (pid) => {
        updateLoadingState(true, 'در حال دریافت اطلاعات');
        const params = {
            pid: pid
        }
        try {
            const response = await fetchProcess(token, params);
            const {hasError, data, message, status} = response;
            updateLoadingState(false, 'لطفا منتظر بمانید.');
            if (hasError) {
                handleError(data, message, status, () => {
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: message,
                        showCancelButton: true,
                        cancelButtonText: 'تلاش مجدد',
                        onCancel: async () => {
                            await handleFetchProcess(pid)
                        }
                    })
                })
            } else {
                setComponents(data.components);
                setProcess(data.process);
                setPid(data.process.pid);
                if (data.components.current_component.name === PLATFORMS.DIVAR.APPS.FIN_CHECK.STEPS.SHAHKAR) {
                    await handleShahkar(data.process.pid)
                } else if (data.components.current_component.name === PLATFORMS.DIVAR.APPS.FIN_CHECK.STEPS.BANKING_OTP_SEND) {
                    await handleBankingOTPSend(data.process.pid);
                } else if (data.components.current_component.name === PLATFORMS.DIVAR.APPS.FIN_CHECK.STEPS.BANKING_OTP_VERIFY) {
                    const time = calculateOtpTimer(data.process.otp_time, 120);
                    if (time <= 0) {
                        await handleBankingOTPSend(data.process.pid);
                    } else {
                        setShowOTP(true);
                    }
                } else if (data.components.current_component.name === PLATFORMS.DIVAR.APPS.FIN_CHECK.STEPS.BACK_CHEQUES_INQUIRY) {
                    await handleBackChequesInquiry(data.process.pid);
                } else if (data.components.current_component.name === PLATFORMS.DIVAR.APPS.FIN_CHECK.STEPS.FACILITY_INQUIRY) {
                    await handleFacilityInquiry(data.process.pid);
                }
            }
        } catch (error) {
            console.error("Fetch Process Error:", error);
            updateLoadingState(false);
        }
    };
    const handleInitConfirm = async (values) => {
        const params = {
            pid,
            "NationalId": persianToEnglish(values.nationalId),
            "is_user_add_on":values.is_user_add_on,
        }
        try {
            updateLoadingState(true, 'در حال ارسال اطلاعات')
            const response = await initConfirm(token, params);
            const {data, status, message, hasError} = response;
            updateLoadingState(false, 'در حال ارسال اطلاعات');
            if (hasError) {
                handleError(data, message, status, () => {
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: message,
                        showCancelButton: true,
                        cancelButtonText: 'تلاش مجدد',
                        onCancel: () => {
                            Reoverlay.hideModal();
                        }
                    })
                }, pid)
            } else {
                await handleFetchProcess(pid);
            }

        } catch (e) {
        }
    };
    const handleCreatePayment = async () => {
        updateLoadingState(true, 'لطفا منتظر بمانید.')
        const params = {
            "pid": pid,
        }
        const response = await createPayment(token, params);
        const {hasError, message, status, data} = response;
        if (hasError) {
            handleError(data, message, status, () => {
                Reoverlay.showModal(ErrorModal, {
                    title: 'خطا',
                    message: message,
                    showCancelButton: true,
                    cancelButtonText: 'تلاش مجدد',
                    onCancel: async () => {
                        await handleCreatePayment()
                    }
                })
            })
        } else {
            if (data.pay_url) {
                updateLoadingState(true, 'در حال انتقال به درگاه بانکی');
                safeRedirect(data.pay_url,()=>{
                    updateLoadingState(false,'')
                    Reoverlay.showModal(ErrorModal,{
                        title:'خطا',
                        message:'لینک معتبر نمی باشد.',
                        showCancelButton: true,
                        cancelButtonText:'بستن',
                        onCancel:()=>{
                            Reoverlay.hideModal();
                            navigate('/404')
                        }
                    })
                })
            }
        }
    };
    const handleShahkar = async (pid) => {
        updateLoadingState(true, 'در حال تطبیق کد ملی و شماره موبایل')
        handleGenerateUuid('Shahkar', token).then(async uuid => {
            const params = {
                pid,
                uuid: uuid
            }
            const response = await shahkar(token, params);
            const {data, status, message, hasError} = response;
            updateLoadingState(false, 'لطفا منتظر بمانید.')
            if (hasError) {

                handleError(data, message, status, () => {
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: message,
                        showCancelButton: true,
                        cancelButtonText: 'تلاش مجدد',
                        onCancel: async () => {
                            await handleShahkar(pid)
                        }
                    })
                }, pid)
            } else {
                await handleFetchProcess(pid)
            }

        }).catch(error => {
            console.log(error);
            updateLoadingState(false, 'در حال تطبیق کد ملی و شماره موبایل')
        });

    };
    const handleBankingOTPSend = async (pid) => {

        updateLoadingState(true, 'در حال ارسال کد اعتبار سنجی');
        setOtpError(null)
        handleGenerateUuid("BankingOTPSend", token).then(async (uuid) => {
            const params = {
                pid,
                uuid,
            }

            try {
                const response = await bankingOTPSend(token, params);
                const {data, status, message, hasError} = response;
                updateLoadingState(false, 'لطفا منتظر بمانید.')
                if (hasError) {
                    handleError(data, message, status, () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message,
                            showCancelButton: true,
                            cancelButtonText: 'در خواست کد ',
                            onCancel: async () => {
                                await handleBankingOTPSend(pid)
                            }
                        })
                    })
                } else {
                    await handleFetchProcess(pid);
                }
            } catch (error) {
                console.error("Request OTP Error:", error);
                updateLoadingState(false);
            }
        })

    };
    const handleBackChequesInquiry = async (pid) => {
        updateLoadingState(true, 'در حال استعلام چک برگشتی');
        handleGenerateUuid("BackChequesInquiry", token).then(async (uuid) => {
            const params = {
                pid,
                uuid,
            }
            try {
                const response = await backChequesInquiry(token, params);
                const {data, status, message, hasError} = response;
                if (hasError) {
                    handleError(data, message, status, () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            onCancel: async () => {
                                await handleBackChequesInquiry(pid)
                            }
                        })
                    })
                } else {
                    await handleFetchProcess(pid);
                }
            } catch (error) {
                console.error("Request OTP Error:", error);
                updateLoadingState(false);
            }
        })

    };
    const handleBankingOTPVerify = async (otpCode) => {

        updateLoadingState(true, 'لطفا منتظر بمانید.');
        handleGenerateUuid("BankingOTPVerify", token).then(async (uuid) => {
            const params = {
                OTP: persianToEnglish(otpCode),
                pid,
                uuid,
            }

            try {
                const response = await bankingOTPVerify(token, params);
                const {message,data, status, hasError} = response;
                updateLoadingState(false);
                if (hasError) {
                    if (status === 225) {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message,
                            showCancelButton: true,
                            cancelButtonText: 'در خواست کد',
                            onCancel: async () => {
                                await handleBankingOTPSend(pid)
                            }
                        })
                    } else {
                        handleError(data,message,status,()=>{
                            setOtpError(message)
                        })
                    }
                } else {
                    await handleFetchProcess(pid);
                }

            } catch (error) {
                console.error("Confirm OTP Error:", error);
                updateLoadingState(false);
            }
        })
    }
    const handleFacilityInquiry = async (pid) => {
        updateLoadingState(true, 'در حال استعلام تسهیلات بانکی');
        handleGenerateUuid("FacilityInquiry", token).then(async (uuid) => {
            const params = {
                pid,
                uuid,
            }

            try {
                const response = await facilityInquiry(token, params);
                const {data, hasError, message, status} = response;
                if (hasError) {
                    handleError(data, message, status, () => {
                        Reoverlay.showModal(ErrorModal, {
                            title: 'خطا',
                            message: message,
                            showCancelButton: true,
                            cancelButtonText: 'تلاش مجدد',
                            onCancel: async () => {
                                await handleFacilityInquiry(pid)
                            }
                        })
                    })
                } else {
                    if (data.warning) {
                        updateLoadingState(false);
                        setMessage(data.warning);
                        setIsReported(true)
                    } else {
                        setMessage("گواهی خوش حسابی شما صادر شده و بر روی آگهی شما درج شده است.");
                        await handleFetchProcess(pid);

                    }


                }

            } catch (error) {
                console.error("Confirm OTP Error:", error);
                updateLoadingState(false);
            }
        })
    }
    const handleComponent = (component) => setComponents(component);
    const handleResetProcess = async (pid) => {
        const params = {
            pid
        }
        updateLoadingState(true, 'در حال بازگشت به مرحله ویرایش اطلاعات');
        try {
            const response = await resetProcess(token, params);
            const {data, status, hasError, message} = response;
            if (hasError) {
                handleError(data, message, status, () => {
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: message,
                        showCancelButton: true,
                        cancelButtonText: 'تلاش مجدد',
                        onCancel: async () => {
                            await handleResetProcess()
                        }
                    })
                })
            } else {
                await handleFetchProcess(pid)
            }
        } catch (error) {
            console.error("Create Process Error:", error);
            updateLoadingState(false);
        }
    }
    const handleDeleteModal = (pid) => {
        Reoverlay.showModal(DeleteWidgetModal, {
            onDelete: async () => {
                await handleDeleteWidget(pid)
            }
        })
    }
    const handleDeleteWidget = async (pid) => {
        updateLoadingState(true, 'در حال حذف افزونه');
        const params = {
            pid,
        }
        try {
            const response = await deleteWidget(token, params);
            updateLoadingState(false, 'لطفا منتظر بمانید.')
            const {hasError, data, status, message} = response;
            if (hasError) {
                handleError(data, message, status, () => {
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: message,
                        showCancelButton: true,
                        cancelButtonText: 'بستن',
                        onCancel: () => {
                            Reoverlay.hideModal()
                        }
                    })
                })
            } else {
                setWidget(null);
                Reoverlay.showModal(SuccessModal, {
                    showConfirmButton: true,
                    showCancelButton: true,
                    title: 'موفق',
                    message,
                    cancelButtonText: 'بازگشت به دیوار',
                    confirmButtonText: 'شروع مجدد',
                    onConfirm: () => {
                        handleInquiryProcess();
                        Reoverlay.hideModal();
                    },
                    onCancel: () => {
                        handleRedirect();
                        Reoverlay.hideModal();
                    }
                })
            }
        } catch (e) {

        }
    }
    useEffect(async () => {
        await handleInquiryProcess()
    }, []);
    return (
        <>
            <FinCheckContext.Provider
                value={{
                    process,
                    pid,
                    postToken,
                    components,
                    token,
                    loading,
                    showOTP,
                    isReported,
                    message,
                    otpError,
                    widget,
                    handleError,
                    updateLoadingState,
                    updateOtpError,
                    handleDeleteModal,
                    handleRedirect,
                    handleInquiryProcess,
                    handleCreateProcess,
                    handleFetchProcess,
                    handleCreatePayment,
                    handleBankingOTPSend,
                    handleBankingOTPVerify,
                    handleBackChequesInquiry,
                    handleComponent,
                    handleInitConfirm,
                    handleShahkar,
                    handleFacilityInquiry,
                }}>
                {children}
            </FinCheckContext.Provider>
        </>
    );
}
export default FinCheckProvider;
